<template>
  <v-dialog
    @keypress="pauseVideo()"
    @click:outside="pauseVideo()"
    origin="bottom center"
    class="pa-0 ma-0"
    v-model="dialog[id]"
    width="800"
    :retain-focus="false"
    :key="id"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex justify-center align-center">
        <img
          v-bind="attrs"
          v-on="on"
          class="card-image d-block"
          :src="files + img"
        />
      </div>
    </template>
    <div class="rounded-3 pa-0 ma-0">
      <v-btn
        color="white"
        class="exit-dialog-button white"
        icon
        @click="(dialog[id] = false), pauseVideo()"
      >
        <v-icon color="red">fas fa-times</v-icon>
      </v-btn>
      <div class="video">
        <iframe
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          class="rounded-3 yt_player_iframe"
          width="100%"
          :src="
            video + `?enablejsapi=1&version=3&playerapiid=ytplayer&autoplay=1`
          "
          allowscriptaccess="always"
        ></iframe>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: {},
    };
  },
  methods: {
    pauseVideo() {
      const youtubeVideo = document.querySelectorAll(".yt_player_iframe");
      youtubeVideo.forEach((e) => {
        e.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      });
    },
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    video: {
      type: String,
      required: true,
    },
  },
  computed: {},
};
</script>
<style>
.v-dialog {
  position: relative;
  overflow: initial;
}
</style>

<style lang="scss" scoped>
iframe {
  display: block;
  border-radius: 4px;
}
.exit-dialog-button {
  position: absolute;
  top: -50px;
  right: -50px;
  @media (max-width: 900px) {
    top: 5px;
    right: 5px;
  }
}
.card-image {
  aspect-ratio: 262/464 !important;
  object-fit: cover;
  width: 100%;
}
</style>
